import { SiuTemplateDirective } from './../../../directives/siu-template.directive';
import { FormType } from './../../../enums/form.enum';
import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  ContentChildren,
  QueryList,
  AfterContentInit
} from '@angular/core';

@Component({
  selector: 'siu-modal-container',
  templateUrl: './modal-container.component.html',
  styleUrls: ['./modal-container.component.scss']
})
export class ModalContainerComponent implements OnInit, AfterContentInit {
  @Input() title: string;
  @Input() loading: boolean = false;
  @Output('on-dismiss') onDismissEvent: EventEmitter<any> = new EventEmitter();
  @Output('on-ok') onOkEvent: EventEmitter<any> = new EventEmitter();
  @Input() showOkButton: boolean = true;
  @Input() grayBackground: boolean = false;
  @Input('ok-label') okLabel: string = 'Guardar';
  @Input() msgErrors: any[];
  @Input() formType: FormType;
  @Input('ok-icon') okIcon: string = 'save';
  @Input() disableRetornar: boolean = false;
  @ContentChildren(SiuTemplateDirective) templates: QueryList<
    SiuTemplateDirective
  >;
  modalLeftActionsTemplate: any = null;

  constructor() {}

  ngOnInit() {}

  HandleDismiss = () => {
    this.onDismissEvent.emit();
  };

  HandleOk = () => {
    this.onOkEvent.emit();
  };

  ngAfterContentInit(): void {
    const tplLeftActions = this.templates.find(
      x => x.getType() === 'left-actions'
    );
    if (tplLeftActions) {
      this.modalLeftActionsTemplate = tplLeftActions.template;
    }
  }
}
